export const RMA_SUMMARY_OF_BUSINESS_SOURCE = "Source: USDA, Risk Management Agency, Summary of Business.";
export const RMA_SUMMARY_OF_BUSINESS_URL = "https://public-rma.fpac.usda.gov/apps/SummaryOfBusiness";
